import type { JSX } from "react";
interface IDropdownProps {
  label: JSX.Element;
  hideOnMobile?: boolean;
  position: 'left' | 'middle' | 'right';
  children: React.ReactNode;
}

const Dropdown: React.FC<IDropdownProps> = ({
  label,
  hideOnMobile = false,
  position,
  children,
}) => {
  // 1. Not including anything related to layout (width, height, zIndex, ...)
  // enable 3x to 4x improved performance (~120ms to ~30ms render time to show
  // and hide dropdown).
  // 2. focus-within is a pseudo selector active when a child is focused ;
  // here it enables us to show the dropdown when navigating with the keyboard.
  const contentClassNames = [
    'tw-absolute tw-top-[120%] tw-z-dropdown tw-opacity-0 tw-transition-all tw-pointer-events-none',
    'group-hover:tw-top-full group-hover:tw-opacity-100 group-hover:tw-pointer-events-auto',
    'focus-within:tw-top-full focus-within:tw-opacity-100 focus-within:tw-pointer-events-auto tw-p-3 tw-pb-2',
  ];

  if (hideOnMobile) {
    contentClassNames.push(' tw-hidden desktop:tw-block');
  }

  switch (position) {
    case 'left':
      contentClassNames.push(' tw-right-0');
      break;
    case 'middle':
      contentClassNames.push(' tw-right-full tw-translate-x-1/2');
      break;
    case 'right':
      contentClassNames.push(' tw-left-0');
      break;
  }

  return (
    <>
      <div className="tw-group tw-relative" aria-haspopup>
        <div className="tw-cursor-pointer">{label}</div>
        <div className={contentClassNames.join(' ')}>{children}</div>
      </div>
    </>
  );
};

export default Dropdown;
